import { SxProps } from '@mui/material';

export const deliveryInformationSX: SxProps = {
	borderBottom: '2px solid',
	borderBottomColor: 'primary.main',
	marginBottom: '1rem',
};
